module.exports = __webpack_public_path__ + "media/images/emblems/Unterschaechen_UR-2c9466e1c07b64f2237ac90b10e4da74.png";